import GroupAction from './GroupAction'

export const ColumnOfData = (
  formatMessage,
  isAdmin,
  onOpenDeleteGroupDialog,
  openEditNameGroupDialog,
  openAddSubgroupDialog,
) => {
  const columns = [
    {
      header: formatMessage({ id: 'group.table.th.groupName' }),
      accessor: 'name',
      style: {
        minWidth: '150px',
      },
      sort: true,
      render: (row) => row.name,
    },
    {
      header: formatMessage({ id: 'group.table.th.subgroups' }),
      accessor: 'tagsCount',
      style: {
        minWidth: '150px',
      },
      sort: true,
      render: (row) => row.tagsCount,
    },
    {
      header: formatMessage({ id: 'group.table.th.subscribers' }),
      accessor: 'subscribersCount',
      sort: false,
      style: {
        minWidth: '150px',
      },
      render: (row) => row.subscribersCount,
    },
  ]

  if (isAdmin) {
    columns.push({
      header: '',
      action: true,
      render: (row) => (
        <>
          <GroupAction
            isAdmin={isAdmin}
            group={row}
            onOpenDeleteGroupDialog={onOpenDeleteGroupDialog}
            openEditNameGroupDialog={openEditNameGroupDialog}
            openAddSubgroupDialog={openAddSubgroupDialog}
          />
        </>
      ),
    })
  }

  return columns
}
